// src/components/store/sections/testimonials/TestimonialV27CardsliderOceanCyan.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV27CardsliderOceanCyan(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={27}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
